import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin, Clock } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "../data/salon";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="marble-soft"
      style={{ borderTop: "1px solid #E8E0D5" }}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-4 flex flex-col items-start">
            <Logo />
            <p
              className="font-serif-display mt-8 text-2xl leading-tight"
              style={{ color: "#1A1A1A", maxWidth: "22rem", fontStyle: "italic", fontWeight: 300 }}
            >
              Frumusețea ta, redefinită — în inima Clujului.
            </p>
            <div className="flex gap-3 mt-8">
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center border transition-colors"
                style={{ borderColor: "#E8E0D5", color: "#1A1A1A" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#B8964E";
                  e.currentTarget.style.color = "#fff";
                  e.currentTarget.style.borderColor = "#B8964E";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#1A1A1A";
                  e.currentTarget.style.borderColor = "#E8E0D5";
                }}
              >
                <Instagram size={16} />
              </a>
              <a
                href={CONTACT.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center border transition-colors"
                style={{ borderColor: "#E8E0D5", color: "#1A1A1A" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#B8964E";
                  e.currentTarget.style.color = "#fff";
                  e.currentTarget.style.borderColor = "#B8964E";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#1A1A1A";
                  e.currentTarget.style.borderColor = "#E8E0D5";
                }}
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <p className="eyebrow mb-6">Navigare</p>
            <ul className="flex flex-col gap-3" style={{ color: "#555" }}>
              {[
                { to: "/", label: "Acasă" },
                { to: "/servicii", label: "Servicii" },
                { to: "/preturi", label: "Prețuri" },
                { to: "/rezervari", label: "Rezervări" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                    className="nav-link"
                    style={{ letterSpacing: "0.16em", fontSize: "0.75rem" }}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <p className="eyebrow mb-6">Contact</p>
            <ul className="flex flex-col gap-4 text-sm" style={{ color: "#555" }}>
              <li className="flex items-start gap-3">
                <MapPin size={15} color="#B8964E" className="mt-0.5 shrink-0" />
                <span>{CONTACT.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={15} color="#B8964E" className="mt-0.5 shrink-0" />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} color="#B8964E" className="mt-0.5 shrink-0" />
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div className="md:col-span-2">
            <p className="eyebrow mb-6">Program</p>
            <ul className="flex flex-col gap-2 text-sm" style={{ color: "#555" }}>
              {CONTACT.hoursShort.map((h) => (
                <li key={h} className="flex items-start gap-3">
                  <Clock size={13} color="#B8964E" className="mt-1 shrink-0" />
                  <span>{h}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className="mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          style={{ borderTop: "1px solid #E8E0D5" }}
        >
          <p className="text-xs tracking-luxe" style={{ color: "#999" }}>
            © {new Date().getFullYear()} LUMIÈRE BEAUTY STUDIO · CLUJ-NAPOCA
          </p>
          <p className="text-xs tracking-luxe" style={{ color: "#999" }}>
            CRAFTED WITH CARE · ROMÂNIA
          </p>
        </div>
      </div>
    </footer>
  );
}
